import { Link } from "react-router";
import styled, { css } from "styled-components";

import contrastColor from "../utils/contrastColor";

interface ILinkProps {
    accent?: string
    active?: boolean
    color?: string
    styled?: boolean
}

const CssBasic = css<ILinkProps>`
    &:hover {
        ${ ({ accent }) => accent ? `color: ${ accent };` : "opacity: .6;" }
    }
`;

const CssStyledActive = css<ILinkProps>`
    box-shadow: inset 0 -.6em 0 0 ${ ({ color, accent }) => accent ?? contrastColor(color) };
    text-decoration: none;
`;

const CssStyled = css<ILinkProps>`
    color: ${ ({ accent, color }) => color ?? contrastColor(accent) };
    padding: 0 2px;
    text-decoration: underline;
    transition: box-shadow 100ms;

    &:hover {
        box-shadow: inset 0 -.6em 0 0 ${ ({ color, accent }) => accent ?? contrastColor(color) };
        text-decoration: none;
    }

    ${ ({ active }) => active && CssStyledActive }
`;

export default styled(Link)<ILinkProps>`
    color: ${ ({ color }) => color ?? "inherit" };

    ${ ({ styled }) => styled ? CssStyled : CssBasic }
`;
